import { ANIMALS, RAMADHAN_SUBS, ZAKAT_JENIS, zakatRecap } from "@/lib/activity";
import { tanggal } from "@/lib/format";
import { PersonChip } from "./PeopleList";

const Box = ({ title, children, testId }) => (
  <div className="rounded-3xl bg-white border border-emerald-900/10 p-6" data-testid={testId}>
    <h3 className="font-semibold text-emerald-950">{title}</h3>
    <div className="mt-4">{children}</div>
  </div>
);

export const ActivityExtras = ({ a }) => {
  const d = a.details || {};
  if (a.category === "qurban") {
    return (
      <Box title="Daftar Hewan Qurban & Panitia" testId="extras-qurban">
        <div className="space-y-3">
          {(d.animals || []).map((an, i) => (
            <div key={i} className="rounded-2xl bg-[#fcfdf9] border border-emerald-900/10 p-4">
              <p className="font-semibold text-emerald-950">{ANIMALS[an.type] || an.type} #{i + 1}</p>
              <ol className="mt-2 grid sm:grid-cols-2 gap-x-6 text-sm text-slate-700 list-decimal list-inside">
                {(an.names || []).filter(Boolean).map((n, j) => <li key={j}>{n}</li>)}
              </ol>
            </div>
          ))}
          {(d.animals || []).length === 0 && <p className="text-sm text-slate-400">Belum ada data hewan.</p>}
          <div className="grid sm:grid-cols-2 gap-4 pt-2">
            <div><p className="text-xs uppercase tracking-widest text-emerald-700 font-semibold">Penjagal</p><p className="text-sm mt-1">{(d.butchers || []).join(", ") || "-"}</p></div>
            <div><p className="text-xs uppercase tracking-widest text-emerald-700 font-semibold">Tim Penjagal</p><p className="text-sm mt-1">{(d.team || []).join(", ") || "-"}</p></div>
          </div>
        </div>
      </Box>
    );
  }
  if (a.category === "ramadhan") {
    return (
      <Box title={`Sub-kegiatan: ${RAMADHAN_SUBS[d.sub] || "-"}`} testId="extras-ramadhan">
        {d.sub === "tarawih" ? (
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-emerald-700"><th className="py-2">Malam ke</th><th>Tanggal</th><th>Imam</th></tr></thead>
            <tbody>
              {(d.tarawih || []).map((t, i) => (
                <tr key={i} className="border-t border-emerald-900/5"><td className="py-2 font-semibold">{t.malam}</td><td>{tanggal(t.date)}</td><td>{a.people_map?.[t.imam_id]?.name || t.imam_name || "-"}</td></tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="text-sm text-slate-600">{d.sub === "itikaf" ? `Penanggung jawab: ${a.pic || "-"}` : "Kuliah subuh bersama pemateri di atas."}</p>
        )}
      </Box>
    );
  }
  if (a.category === "zakat_fitrah") {
    const recap = zakatRecap(d.muzakki);
    return (
      <Box title="Rekap Zakat Fitrah" testId="extras-zakat">
        <p className="text-sm text-slate-600">Periode penerimaan: {tanggal(d.period_start)} – {tanggal(d.period_end)} · Petugas: {d.petugas || "-"}</p>
        <div className="mt-4 grid sm:grid-cols-3 gap-3">
          <div className="rounded-2xl bg-emerald-50 p-4"><p className="text-xs text-emerald-700">Muzakki</p><p className="text-2xl font-extrabold text-emerald-950">{(d.muzakki || []).length}</p></div>
          <div className="rounded-2xl bg-[#f6ebd0] p-4"><p className="text-xs text-[#8a6d14]">Beras</p><p className="text-2xl font-extrabold text-emerald-950">{recap.beras || 0} kg</p></div>
          <div className="rounded-2xl bg-sky-50 p-4"><p className="text-xs text-sky-700">Uang</p><p className="text-2xl font-extrabold text-emerald-950">Rp {Number(recap.uang || 0).toLocaleString("id-ID")}</p></div>
        </div>
        <p className="mt-4 text-xs uppercase tracking-widest text-emerald-700 font-semibold">Mustahiq & Distribusi ({(d.mustahiq || []).length})</p>
        <ul className="mt-2 text-sm text-slate-700 grid sm:grid-cols-2 gap-x-6">
          {(d.mustahiq || []).map((m, i) => <li key={i} className="border-b border-emerald-900/5 py-1">{m.name} — {m.jumlah} {m.keterangan && <span className="text-slate-400">({m.keterangan})</span>}</li>)}
        </ul>
      </Box>
    );
  }
  if (a.category === "donor_darah" && d.organizer) {
    return <Box title="Penyelenggara" testId="extras-donor"><p className="text-sm text-slate-700">{d.organizer}</p></Box>;
  }
  return null;
};

export { PersonChip };
